var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSledovat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_125_39724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 2.91797C4.66602 2.91797 1.81935 4.9913 0.666016 7.91797C1.81935 10.8446 4.66602 12.918 7.99935 12.918C11.3327 12.918 14.1793 10.8446 15.3327 7.91797C14.1793 4.9913 11.3327 2.91797 7.99935 2.91797ZM7.99935 11.2513C6.15935 11.2513 4.66602 9.75797 4.66602 7.91797C4.66602 6.07797 6.15935 4.58464 7.99935 4.58464C9.83935 4.58464 11.3327 6.07797 11.3327 7.91797C11.3327 9.75797 9.83935 11.2513 7.99935 11.2513ZM7.99935 5.91797C6.89268 5.91797 5.99935 6.8113 5.99935 7.91797C5.99935 9.02464 6.89268 9.91797 7.99935 9.91797C9.10602 9.91797 9.99935 9.02464 9.99935 7.91797C9.99935 6.8113 9.10602 5.91797 7.99935 5.91797Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_125_39724"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.25)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSledovat);
export default __webpack_public_path__ + "static/media/icon-sledovat.202a34354c7776bb111bf10baf0664ad.svg";
export { ForwardRef as ReactComponent };